/**
 * @generated SignedSource<<72419a37f14ef2982e2238dc79519325>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type templateCatalogListQuery$variables = {
  categoryID?: number | null;
};
export type templateCatalogListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"templateCatalogPaginationFragment__productTemplates">;
};
export type templateCatalogListQuery = {
  response: templateCatalogListQuery$data;
  variables: templateCatalogListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryID"
  }
],
v1 = {
  "kind": "Variable",
  "name": "categoryID",
  "variableName": "categoryID"
},
v2 = [
  {
    "kind": "Literal",
    "name": "after",
    "value": "1"
  },
  (v1/*:: as any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  {
    "kind": "Literal",
    "name": "search",
    "value": ""
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "templateCatalogListQuery",
    "selections": [
      {
        "args": [
          (v1/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "templateCatalogPaginationFragment__productTemplates"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "templateCatalogListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "ProductTemplatesConnection",
        "kind": "LinkedField",
        "name": "productTemplates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductTemplatesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Model",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "largeImageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "filters": [
          "search",
          "categoryID"
        ],
        "handle": "connection",
        "key": "templateCatalogPaginationFragment_productTemplates",
        "kind": "LinkedHandle",
        "name": "productTemplates"
      }
    ]
  },
  "params": {
    "cacheID": "9f402587fcca7e5ae834ae5562677eef",
    "id": null,
    "metadata": {},
    "name": "templateCatalogListQuery",
    "operationKind": "query",
    "text": "query templateCatalogListQuery(\n  $categoryID: Long\n) {\n  ...templateCatalogPaginationFragment__productTemplates_2XGewc\n}\n\nfragment templateCatalogPaginationFragment__productTemplates_2XGewc on Query {\n  productTemplates(first: 20, after: \"1\", search: \"\", categoryID: $categoryID) {\n    edges {\n      node {\n        id\n        name\n        largeImageUrl\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c359638c1a75eb52a642102e32651e1";

export default node;
